import {
  type IndexedPageFootnote,
  usePageFootnotes,
} from 'hooks/usePageFootnotes';
import { useShallow } from 'zustand/react/shallow';

import { type DisclaimerContent, useDisclaimers } from './useDisclaimers';

type FooterInputOverrides = {
  disclaimers?: DisclaimerContent | null;
  pageFootnotes?: IndexedPageFootnote[];
};

export const useFooterInputs = ({
  disclaimers: disclaimersOverride,
  pageFootnotes: pageFootnotesOverride,
}: FooterInputOverrides) => {
  const hookDisclaimers = useDisclaimers();
  const hookPageFootnotes = usePageFootnotes(
    useShallow((state) => [...state.footnotes.values()]),
  );

  return {
    disclaimers:
      disclaimersOverride === undefined ? hookDisclaimers : disclaimersOverride,
    pageFootnotes: pageFootnotesOverride ?? hookPageFootnotes,
  };
};
